import React from 'react';
import {Field} from 'redux-form';
import {Form, Row, Col} from 'react-bootstrap';
import Button from '@material-ui/core/Button';
import moment from 'moment/moment';
import {fetchSchools} from 'api';
import {AutoSuggestSelect} from 'components/common';
import * as fields from 'components/common/fields';
import * as validators from 'utils/validators';
import {makeForm, getDefaultSubscriptionExpiryDate, momentDatetime} from 'utils/common';

class OrderForm extends React.Component {
  constructor(props) {
    super(props);
    this.fetchSchools = this.fetchSchools.bind(this);
    this.dateToday = moment();
  }

  fetchSchools(value) {
    return fetchSchools(value, undefined, undefined, undefined, {includeArchived: true}).then(({records}) => records);
  }

  render() {
    const {handleSubmit, pristine, submitting} = this.props;
    return (
      <Form onSubmit={handleSubmit}>
        <Row>
          <Col md={6}>
            <Field
              name="name"
              label="Purchase order"
              component={fields.Input}
              required
              validate={[validators.isRequired]}
            />
          </Col>
          <Col md={6}>
            <Field
              name="subscriptions"
              label="Number of Subscriptions"
              component={fields.Input}
              required
              validate={[validators.isRequired, validators.isSafePositiveInteger]}
            />
          </Col>
          <Col md={6}>
            <Field
              name="expiryDate"
              label="Expiry Date"
              minDate={this.dateToday}
              component={fields.DatePicker}
              required
              validate={[validators.isRequired]}
            />
          </Col>
          <Col md={6}>
            <AutoSuggestSelect
              name="school"
              label="School"
              labelKey="name"
              valueKey="id"
              onSearch={this.fetchSchools}
              required
              validate={[validators.isRequired]}
            />
          </Col>
        </Row>
        <Row>
          <Col xs={12}>
            <Button type="submit" variant="contained" color="primary" fullWidth disabled={pristine || submitting}>
              Submit
            </Button>
          </Col>
        </Row>
      </Form>
    );
  }
}

const mapStateToProps = {
  Creation: () => ({
    initialValues: {
      expiryDate: getDefaultSubscriptionExpiryDate(),
    },
  }),
  Update: (state, {order}) => {
    return {
      initialValues: {
        ...order,
        expiryDate: order.expiryDate ? momentDatetime(order.expiryDate, true) : null,
      },
    };
  },
};

export default {
  Creation: makeForm(OrderForm, 'OrderForm.Creation', mapStateToProps.Creation, null),
  Update: makeForm(OrderForm, 'OrderForm.Update', mapStateToProps.Update, null),
};
